import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ChangeContentOwnerAction } from '~src/spacesPlatform/actions/ChangeContentOwnerAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { SetOwnerAction } from '~src/spacesPlatform/actions/SetOwnerAction';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { Users } from '../../userManagement/services/resources/Users';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';

export function* handleSetOwner(action: SetOwnerAction): SagaIterator {

  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.items);

    try {
      yield call(openSetContentOwnerDialog, mutatableContentCopy);
    } catch {
      return;
    }

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.items);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openSetContentOwnerDialog(items: IContentInfo[]): Promise<IResult> {
  return ChangeContentOwnerAction.confirmChangeOwner(items);
}

export function getUser(userId: string): Promise<IUserInfo> {
  return Users.instance.getById(userId);
}
